<div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
  <div class="_g-border-dashed col-span-1 gap-y-2">
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.purchaseNo" | translate }}</span>
      <span>{{ purchaseData.purchaseNo }} </span>
    </div>

    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.branch" | translate }}/{{ "purchaseDetailList.customer" | translate }} </span>
      <span>
        @if (purchaseData.member) {
          {{ purchaseData.member.firstname }} {{ purchaseData.member.lastname }}
        } @else {
          @if (purchaseData.bulkSaleBranch) {
            {{ purchaseData.bulkSaleBranch.name }}  {{ purchaseData.bulkSaleBranch.branchName }}
          } @else {
            -
          }
        }
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.sellType" | translate }}</span>
      <span>
        @if (purchaseData.member) {
          <p-tag
            severity="secondary"
            value="{{ !purchaseData.member ? '-' : (purchaseData.member.memberTier.translations | translations: 'name') }}"
            [rounded]="true"
          />
        } @else {
          @if (purchaseData.bulkSaleBranch) {
            <p-tag
              severity="secondary"
              value="{{ !purchaseData.bulkSaleBranch.franchiseTier? '-' : (purchaseData.bulkSaleBranch.franchiseTier.translations | translations: 'name') }}"
              [rounded]="true"
            />
          }
        }
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.branchPurchase" | translate }}</span>
      <span>
        @if (purchaseData.branch) {
          {{ purchaseData.branch.branchName }}
        } @else {
          -
        }
      </span>
    </div>

    @if (purchaseData.isBulkSale) {
      <div class="_wrapper">
        <span class="_left w-[158px]">{{ "purchaseDetailList.license" | translate }}</span>
        <span>{{ purchaseData.carLicensePlate ? purchaseData.carLicensePlate : "-" }}</span>
      </div>

      <div class="_wrapper">
        <span class="_left w-[158px]">{{ "purchaseDetailList.timeIn" | translate }}</span>
        <span>
          {{ !purchaseData.checkInTime ? "-" : (purchaseData.checkInTime | date: "HH:mm") }}
        </span>
      </div>
      <div class="_wrapper">
        <span class="_left w-[158px]">{{ "weighing.weighingIn" | translate }}</span>
        <span> {{ purchaseData.weightIn | number: "1.2" : "en-US" }} ตัน </span>
      </div>
      <div class="_wrapper">
        <span class="_left w-[158px]">{{ "weighing.weighingTimeOut" | translate }}</span>
        <span>
          {{ !purchaseData.checkOutTime ? "-" : (purchaseData.checkOutTime | date: "HH:mm") }}
        </span>
      </div>

      <div class="_wrapper">
        <span class="_left w-[158px]">{{ "weighing.weighingOut" | translate }}</span>
        <span>
          {{ purchaseData.weightOut | number: "1.2" : "en-US" }}
        </span>
      </div>
    }
  </div>

  <div class="col-span-1 gap-y-2">
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "status" | translate }}</span>
      <span>
        @if (purchaseData.status === statusPurchaseType.Paid) {
          <p-tag
            class="mt-1"
            severity="success"
            [value]="purchaseStatusEnumText[purchaseData.status]"
            rounded
          />
        } @else if (purchaseData.status === statusPurchaseType.PendingReview) {
          <p-tag
            class="mt-1"
            severity="secondary"
            [value]="purchaseStatusEnumText[purchaseData.status]"
            rounded
          />
        } @else if (purchaseData.status === statusPurchaseType.PendingPayment) {
          <p-tag
            class="mt-1"
            severity="info"
            [value]="purchaseStatusEnumText[purchaseData.status]"
            rounded
          />
        } @else {
          <p-tag
            class="mt-1"
            severity="danger"
            [value]="purchaseStatusEnumText[purchaseData.status]"
            rounded
          />
        }
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchasingStaff" | translate }}</span>
      <span>
        @if (purchaseData.recordedBy) {
          {{ purchaseData.recordedBy.firstname }} {{ purchaseData.recordedBy.lastname }}
        } @else {
          -
        }
      </span>
    </div>

    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.dateTimeToPurchasingStaff" | translate }}</span>
      <span> {{ purchaseData.createdAt | libDate: "dateTime" }}</span>
    </div>

    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "examine" | translate }}</span>
      <span>
        @if (purchaseData.approvedBy) {
          {{ purchaseData.approvedBy.firstname }} {{ purchaseData.approvedBy.lastname }}
        } @else {
          -
        }
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.dateTimeToExamine" | translate }}</span>
      <span> {{ !purchaseData.approvedAt ? "-" : (purchaseData.approvedAt | libDate: "dateTime") }}</span>
    </div>

    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.cashier" | translate }}:</span>
      <span>
        @if (purchaseData.cashier) {
          {{ purchaseData.cashier.firstname }} {{ purchaseData.cashier.lastname }}
        } @else {
          -
        }
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[158px]">{{ "purchaseDetailList.dateTimeToCount" | translate }}</span>
      <span> {{ !purchaseData.cashierAt ? "-" : (purchaseData.cashierAt | libDate: "dateTime") }}</span>
    </div>
  </div>
</div>
